import logo from '../../../../../assets/logo/mobile-logo.png';
interface LoadingProps {
  label?: string;
}

const FullLoading = ({ label = 'Loading...' }: LoadingProps) => {
  return (
    <>
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-100 dark:bg-darkModeBackground">
        <img src={logo} alt="Logo" className="w-10 h-10" />
        <p className="mt-3 text-gray-600 text-xs font-medium">{label}</p>
      </div>
    </>
  );
};

export default FullLoading;
